/**
 * One sentence per way asking to hear a dub can fail, for the two screens that
 * offer the Voice control.
 *
 * Pressing a control no longer runs anything: it writes three values onto the
 * timeline, and the dub engine builds the audio when a document is produced. So
 * the only failure left with a sentence is asking to hear a dub the story does
 * not have. The story wording is the base and the clip screen overrides only
 * the sentence that differs.
 */

/** Which way asking to hear a dub failed. */
export type DubApplyFailure = 'no-dub';

export const STORY_DUB_APPLY_MESSAGES: Record<DubApplyFailure, string | null> =
  {
    'no-dub':
      'There is no dub for this language yet. Generate one from the Transcript and Speakers tab, then try again.',
  };

/** The clip preview: the same outcome, said about one clip. */
export const CLIP_DUB_APPLY_MESSAGES: Record<DubApplyFailure, string | null> = {
  ...STORY_DUB_APPLY_MESSAGES,
};
